import { FormsArchiveFilterTableStatus, FormsFilterTableStatus } from 'app-constants';

export const FORM_TABS = {
  ...FormsFilterTableStatus,
  ...FormsArchiveFilterTableStatus,
  Completed: 'Completed',
  RecentlyCompleted: 'Recently Completed',
  Cancelled: 'Canceled',
  Archive: 'Archive',
};

export const getTabStatusByValue = (activeTabValue) =>
  Object.keys(FORM_TABS).find((k) => FORM_TABS[k] === activeTabValue);

export const defaultPagination = { total: 0, page: 0, pageSize: 0 };
export const formsEmptyText = 'No Forms.';
